import { baseApi, Http, rtkq, RtkqRequest } from '@app/base';
import { GetConsentTemplateDocument, GetConsentTemplatesDocument, ConsentTemplate } from './graphql';
import {
  CreateConsentTemplateRequest,
  ConsentTemplateListItem,
  UpdateConsentTemplateRequest,
} from './consentTemplatesTypes';

export const consentTemplatesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllConsentTemplates: build.query<ConsentTemplateListItem[], RtkqRequest<void>>({
      queryFn: rtkq.graphql(GetConsentTemplatesDocument, {
        select: (x) => x.consentTemplates as ConsentTemplateListItem[],
      }),
      providesTags: (result = []) => [
        { type: 'main:consent-template-collection', id: 'list' },
        ...result.flatMap(({ id }) => ({
          type: 'main:consent-template-collection' as const,
          id: id,
        })),
      ],
    }),
    getConsentTemplate: build.query<ConsentTemplate, RtkqRequest<{ id: string }>>({
      queryFn: rtkq.graphql(GetConsentTemplateDocument, {
        select: (x) => x.consentTemplate as ConsentTemplate,
        vars: ({ id }) => ({ id }),
      }),
      providesTags: (_, __, { id }) => [
        {
          type: 'main:consent-template' as const,
          id: id,
        },
      ],
    }),

    createConsentTemplate: build.mutation<string, RtkqRequest<CreateConsentTemplateRequest>>({
      queryFn: rtkq.axios((args) => Http.post('/api/consent-template', args)),
      invalidatesTags: () => [
        { type: 'main:consent-template', id: 'list' },
        { type: 'main:consent-template-collection', id: 'list' },
      ],
    }),
    updateConsentTemplate: build.mutation<string, RtkqRequest<UpdateConsentTemplateRequest>>({
      queryFn: rtkq.axios((args) => Http.put(`/api/consent-template/${args.id}`, args)),
      invalidatesTags: (_, __, { id }) => [
        { type: 'main:consent-template-collection', id: 'list' },
        { type: 'main:consent-template', id: id },
      ],
    }),
    deleteConsentTemplate: build.mutation<string, RtkqRequest<{ id: string }>>({
      queryFn: rtkq.axios((args) => Http.delete(`/api/consent-template/${args.id}`)),
      invalidatesTags: (_, __, { id }) => [
        { type: 'main:consent-template-collection', id: 'list' },
        { type: 'main:consent-template', id: id },
      ],
    }),
  }),
});

export const {
  useGetAllConsentTemplatesQuery,
  useLazyGetAllConsentTemplatesQuery,
  useGetConsentTemplateQuery,
  useCreateConsentTemplateMutation,
  useUpdateConsentTemplateMutation,
  useDeleteConsentTemplateMutation,
} = consentTemplatesApi;
